import { downloadPdf } from "shared/helpers/client";
import { toast } from "react-toastify";

/**
 * Downloads the Ticket Bill PDF for the given ticket ID.
 * Calls GET /api/report/ticket-bill/{id}?lang={lang}
 *
 * @param ticketId  - The Trip_Ticket.id value
 * @param lang      - Column language: "ArName" (Arabic, default) | "EName" (English)
 */
export async function downloadTicketBillPdf(
  ticketId: number,
  lang: "ArName" | "EName" = "ArName"
): Promise<void> {
  try {
    await downloadPdf(
      `/api/report/ticket-bill/${ticketId}?lang=${lang}`,
      `ticket-bill-${ticketId}.pdf`
    );
  } catch (err) {
    console.error("PDF download error:", err);
    toast.error("Failed to generate PDF. Please try again.");
  }
}
